export const ConsumerPostSubmissionFailedViewMessages = {
  failedMessage: {
    id: 'Pages.PostSubmission.Failed.View.label',
    description:
      'Oops! Something went wrong. Click the button below to try again.'
  }
}
